<template>
    <v-popover offset="8" class="w-100" :container="false" ref="vpop">
        <button
            class="btn-generate-labels btn btn-secondary ml-auto btn-block"
            :disabled="isDisabled"
            @click="onClick"
        >
            {{ textButton }}
        </button>

        <template slot="popover">
            <popover-confirm
                :message="messages[currentMsgIdx].message"
                :abort-text="messages[currentMsgIdx].textAbort || textAbort"
                :abort-btn-class="abortBtnClass"
                :confirm-text="
                    messages[currentMsgIdx].textConfirm || textConfirm
                "
                :close-on-confirm="false"
                :no-close-on-abort="messages[currentMsgIdx].noCloseOnAbort"
                :loading-status="messages[currentMsgIdx].loadingStatus"
                :hide-abort-btn="messages[currentMsgIdx].hideAbortBtn"
                :hide-confirm-btn="messages[currentMsgIdx].hideConfirmBtn"
                @confirmed="onConfirm()"
                @aborted="onAbort()"
            />
        </template>
    </v-popover>
</template>

<script>
export default {
    props: {
        messages: {
            type: Array,
            required: true
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        textButton: {
            type: String,
            default: 'Przejdź dalej'
        },
        textConfirm: {
            type: String,
            default: 'Akceptuję'
        },
        textAbort: {
            type: String,
            default: 'Cofnij'
        },
        abortBtnClass: {
            type: String,
            default: 'btn btn-sm btn-danger'
        }
    },
    data() {
        return {
            currentMsgIdx: 0
        }
    },
    methods: {
        onConfirm(confirmOnAbortMsg) {
            if (
                this.messages[this.currentMsgIdx].closeOnConfirmMsg &&
                !confirmOnAbortMsg
            ) {
                this.$refs.vpop.hide()
                this.currentMsgIdx = 0
            } else if (this.currentMsgIdx < this.messages.length - 1) {
                this.$emit('onChangeMsgIdx')
                this.currentMsgIdx++
            } else {
                this.$refs.vpop.hide()
                this.$emit('onConfirm', true)
                this.currentMsgIdx = 0
            }
        },
        onAbort() {
            if (this.messages[this.currentMsgIdx].confirmOnAbortMsg) {
                this.onConfirm(
                    this.messages[this.currentMsgIdx].confirmOnAbortMsg
                )
            } else {
                this.$emit(
                    'onAbort',
                    this.currentMsgIdx === this.messages.length - 1
                )
                this.currentMsgIdx = 0
            }
        },
        onClick() {
            this.$emit(
                'onClick',
                this.currentMsgIdx === this.messages.length - 1
            )
        }
    }
}
</script>
